const o="geo_locator:events";export{o as GEO_LOCATOR_EVENTS_CHANNEL};
//# sourceMappingURL=events.js.map
